import type { ComponentProps } from 'react'

import {
  ICON_DEFAULT_COLOR,
  ICON_DEFAULT_FILL,
  ICON_DEFAULT_HEIGHT,
  ICON_DEFAULT_VIEWBOX,
  ICON_DEFAULT_WIDTH,
  type IconProps,
} from 'components'

export const Note = ({
  color = ICON_DEFAULT_COLOR,
  fill = ICON_DEFAULT_FILL,
  width = ICON_DEFAULT_WIDTH,
  height = ICON_DEFAULT_HEIGHT,
  viewBox = ICON_DEFAULT_VIEWBOX,
  ...props
}: ComponentProps<'svg'> & Omit<IconProps, 'icon'>) => {
  return (
    <svg
      fill={fill}
      height={height}
      viewBox={viewBox}
      width={width}
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M20.6594 4.5625L26.6812 10.5844C27.2099 11.1125 27.6046 11.7594 27.8324 12.471C28.0603 13.1826 28.1147 13.9385 27.9912 14.6754C27.8676 15.4124 27.5697 16.1091 27.1222 16.7075C26.6748 17.306 26.0907 17.7887 25.4187 18.1156L20.2719 20.6219C19.5279 20.9844 18.9581 21.6272 18.6875 22.4094L17.5 25.8531C17.327 26.3542 17.0293 26.8029 16.6351 27.1573C16.2408 27.5116 15.7629 27.7598 15.2463 27.8786C14.7297 27.9973 14.1914 27.9827 13.682 27.8361C13.1726 27.6896 12.7088 27.4158 12.3344 27.0406L9.375 24.0812L5.33438 28.1187H3.125V25.9094L7.16563 21.875L4.20313 18.9125C3.82869 18.538 3.55557 18.0745 3.40941 17.5654C3.26326 17.0564 3.24887 16.5186 3.36758 16.0025C3.4863 15.4864 3.73424 15.0089 4.08811 14.6149C4.44198 14.2209 4.89018 13.9233 5.39062 13.75L8.83437 12.5625C9.22305 12.4278 9.5813 12.2176 9.88858 11.9441C10.1959 11.6706 10.4461 11.3392 10.625 10.9687L13.1313 5.82187C13.4581 5.14993 13.9409 4.56587 14.5393 4.11839C15.1378 3.67091 15.8345 3.37298 16.5715 3.24944C17.3084 3.1259 18.0642 3.18034 18.7759 3.4082C19.4875 3.63607 20.1344 4.03076 20.6625 4.55937L20.6594 4.5625ZM6.25 35.9375V31.0219L9.23125 28.0406L9.375 28.1812V35.9375C9.375 37.1807 9.86886 38.373 10.7479 39.2521C11.627 40.1311 12.8193 40.625 14.0625 40.625H25V32.8125C25 30.7405 25.8231 28.7534 27.2882 27.2882C28.7534 25.8231 30.7405 25 32.8125 25H40.625V14.0625C40.625 12.8193 40.1311 11.627 39.2521 10.7479C38.373 9.86886 37.1807 9.375 35.9375 9.375H29.5688C29.4413 9.22488 29.3079 9.07997 29.1687 8.94062L26.4781 6.25H35.9375C38.0095 6.25 39.9966 7.0731 41.4618 8.53822C42.9269 10.0034 43.75 11.9905 43.75 14.0625V25.5375C43.7496 27.6086 42.9268 29.5947 41.4625 31.0594L31.0594 41.4625C29.5947 42.9268 27.6086 43.7496 25.5375 43.75H14.0625C11.9905 43.75 10.0034 42.9269 8.53823 41.4618C7.0731 39.9966 6.25 38.0095 6.25 35.9375ZM28.125 39.8437C28.3844 39.6719 28.625 39.475 28.85 39.25L39.2531 28.85C39.475 28.6281 39.6719 28.3844 39.8469 28.125H32.8125C31.5693 28.125 30.377 28.6189 29.4979 29.4979C28.6189 30.377 28.125 31.5693 28.125 32.8125V39.8437Z"
        fill={color}
      />
    </svg>
  )
}
